import { useRef } from 'react';
import emailjs from 'emailjs-com';
import ScrollToTop from "react-scroll-to-top";
import './Footer.css';

const Footer = () => {

  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();
    try {
      const res = await emailjs.sendForm(
        'service_lvofl38',
        'template_nj0uh7f',
        form.current,
        '7A7YvLzgZsuOzLV9D')
      if (res?.status === 200) {
        e.target.reset();
        alert('Message sent successfully!');
      }
    }
    catch (err) {
      alert("Something went wrong!");
    }
  };

  return (
    <div className="background">
      <ScrollToTop smooth color="#6f00ff" />

      <div id="contact" className="container section">
        <div className="row contacts">

          <div className="col-md-8 col-lg-8">
            <h3 className="contacts__form-title">Get in Touch with Me</h3>
            <div className="contacts__form">

              <form className="js-form" ref={form} onSubmit={sendEmail}>
                <div className="form-group">
                  <input className="form-field js-field-name" type="text" placeholder="Enter your name" required name="name" id="validationCustom01" />
                  <span className="form-validation"></span>
                  <span className="form-invalid-icon"><i className="mdi mdi-close" aria-hidden="true"></i></span>
                </div>
                <div className="form-group">
                  <input className="form-field js-field-email" type="email" placeholder="Enter your email" required name="email" id="validationCustom02" />
                  <span className="form-validation"></span>
                  <span className="form-invalid-icon"><i className="mdi mdi-close" aria-hidden="true"></i></span>
                </div>
                <div className="form-group">
                  <textarea className="form-field js-field-message" placeholder="Type the message here" required name="message" id="validationCustom03"></textarea>
                  <span className="form-validation"></span>
                  <span className="form-invalid-icon"><i className="mdi mdi-close" aria-hidden="true"></i></span>
                </div>
                <button className="site-btn site-btn--form" type="submit" value="Send">Send</button>
              </form>

            </div>
          </div>

          <div className="contacts__social col-md-2 pt-4 pt-md-0">
            <ul style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <li><a href="https://github.com/Yeasin307" target="_blank" rel="noreferrer"><i style={{ fontSize: '32px' }} className="fa fa-github"></i></a></li>
              <li><a href="https://www.linkedin.com/in/yeasinhossen/" target="_blank" rel="noreferrer"><i style={{ fontSize: '32px' }} className="fa fa-linkedin-square"></i></a></li>
            </ul>
          </div>

          <div className="footer ps-md-5 ms-md-5 mt-5">
            <p>Copyright © 2026 Yeasin Hossen. All Rights Reserved</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Footer;